<template>
	<transition
			appear
			:appear-active-class="$_inpSwt_styleInputSwitchAnimation()">
		<v-row no-gutters>
			<v-col>
				<template v-for="(answerOptionVals, answerOptionKey) in sortObject(contents[contentKey].options, 'order')">
					<v-row :key="answerOptionKey" no-gutters>
						<v-col style="max-width: 48px">
							<validation-provider
									:name="'InputSwitch-' + contentKey"
									:rules="getValidationRules(contents[contentKey].rules)"
									v-slot="{ errors }">
								<v-switch
										class="switch_"

										v-model="$store.state.input.data[contentKey].answer[answerOptionKey].value"

										hide-details

										:background-color="$_inpSwt_styleSwitchBackgroundColor"
										:color="$_inpSwt_styleSwitchColor"
										:dark="$_inpSwt_styleSwitchDark"
										:light="$_inpSwt_styleSwitchLight"

										:append-icon="$_inpSwt_styleParamAppendIcon(contents[contentKey].params)"
										:prepend-icon="$_inpSwt_styleParamPrependIcon(contents[contentKey].params)"

										:error-messages="errors" />
							</validation-provider>
						</v-col>
						<v-col class="start">
							<span class="switch_" v-text="$_inpSwt_langAnswerOptionText(answerOptionVals)" />
						</v-col>
					</v-row>
				</template>
				<template v-if="!isEmpty(contents[contentKey].params.hint)">
					<v-row>
						<v-col>
							<span class="hint_" v-text="$_inpSwt_langParamHint(contents[contentKey].params)" />
						</v-col>
					</v-row>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputSwitch',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_inpSwt_langParamHint() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.hint;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSwt_langAnswerOptionText() {
				const self_ = this;
				return answerOptionVals => {
					const answerOptionVal_ = answerOptionVals.text;
					if(self_.isFalse(answerOptionVal_)) { return null }
					return self_.getLangsVal(answerOptionVal_)
				}
			},
			// style
			$_inpSwt_styleInputSwitch() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputSwitch')
				}
			},
			$_inpSwt_styleInputSwitchAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpSwt_styleInputSwitch()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpSwt_styleSwitch() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'switch')
			},
			$_inpSwt_styleSwitchBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpSwt_styleSwitch;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpSwt_styleSwitchColor() {
				const self_ = this;
				const style_ = self_.$_inpSwt_styleSwitch;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpSwt_styleSwitchDark() {
				const self_ = this;
				const style_ = self_.$_inpSwt_styleSwitch;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpSwt_styleSwitchLight() {
				const self_ = this;
				const style_ = self_.$_inpSwt_styleSwitch;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_inpSwt_styleParamAppendIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpSwt_styleParamPrependIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			}
		}
	}
</script>

<style scoped>
	.switch_ {
		padding-top: 20px;
		margin-top: 0;
	}
	.hint_ {
		font-size: small;
	}
</style>
